import { useEffect } from 'react';
import { useTranslate } from 'i18n-calypso';
import { addQueryArgs, getQueryArgs } from '@wordpress/url';

import OverviewSidebar from 'sections/overview/sidebar';
import Layout from 'components/layout';
import Content from 'components/content';

export default function Auth() {
	const translate = useTranslate();

	// @ts-expect-error The variable is injected by webpack.DefinePlugin.
	const authUrl = new URL( HPP_OAUTH2_AUTHORIZE_URL );
	const redirect = getQueryArgs( window.location.search )?.return?.toString() || '';

	authUrl.search = new URLSearchParams( {
		response_type: 'token',
		// @ts-expect-error The variable is injected by webpack.DefinePlugin.
		client_id: `${ HPP_OAUTH2_CLIENT_ID }`,
		// @ts-expect-error The variable is injected by webpack.DefinePlugin.
		redirect_uri: addQueryArgs( `${ HPP_ORIGIN }/auth/token`, { return: redirect } ),
		scope: 'global',
	} ).toString();

	useEffect( () => {
		window.location.replace( authUrl.toString() );
	}, [] );

	return (
		<Layout Sidebar={ OverviewSidebar }>
			<Content className="flex justify-center items-center">
				<p className="text-center">
					{ translate( 'You will be redirected to login at WordPress.com.' ) }<br />
					<a href={ authUrl.toString() }>{ translate( 'Click here to log in manually.' ) }</a>
				</p>
			</Content>
		</Layout>
	);
}
